module.exports = __webpack_public_path__ + "static/media/spendee.7dbe9878.jpg";